<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon
          name="cil-bell"
          size="xl"
        />
        <CBadge
          color="danger"
          v-if="qnt > 0"
          class="ml-auto"
        >{{ qnt }}</CBadge>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Notificações</strong>
    </CDropdownHeader>
    <template
      :v-if="notif.length > 0"
      v-for="(item, index) in notif"
    >
      <CDropdownItem
        :key="index"
        @click="open_notification(item)"
      >
        <template #default>
          <div style="min-width: 250px;">
            <CRow>
              <CCol
                class="my-auto mr-4 py-auto"
                sm="2"
              >
                <CImg
                  height="40px"
                  width="40px"
                  v-if="qnt > 0"
                  shape="rounded-circle"
                  :src="getUrlImg(item.foto_perfil)"
                />
              </CCol>
              <CCol
                class="my-auto py-auto"
                align="left"
              >
                <h6 class="py-0 my-0">{{item.titulo}}</h6>
                <p class="py-0 my-0">{{item.sub_titulo}}</p>
              </CCol>
              <CCol
                class="my-auto py-auto"
                align="right"
              >
                <p class="py-0 my-0">{{item.time}}</p>
              </CCol>
            </CRow>
          </div>
        </template>
      </CDropdownItem>
    </template>
  </CDropdown>
</template>

<script>
const axios = require("axios");

export default {
  name: "NotificacoesUsuarios",
  data() {
    return {
      notif: [],

      qnt: 0,
    };
  },

  created() {
        if (window.location.hostname == "bikersecodelivery.com.br" || window.location.hostname == "www.bikersecodelivery.com.br" ) {

      this.url = "https://laravel.bikersecodelivery.com.br";
    } else if (window.location.hostname == "localhost") {
      this.url = "http://127.0.0.1:8000";
    } else if (window.location.hostname == "teste.bikersecodelivery.com.br") {
      this.url = "https://teste-laravel.bikersecodelivery.com.br";
    }
    sessionStorage.setItem("url", this.url);

    if (this.getToken) {
      axios
        .get(sessionStorage.getItem("url") + "/api/usuario-autenticado", {
          headers: { Authorization: "Bearer " + this.getToken },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired") {
            this.$store.commit("DESTROY_USER");
            this.$router.push("/");
          }
          this.$store.commit("SET_USER", response.data);
          this.atualiza_notificacoes(response.data.id);
          if (response.data.desativado == 1) {
            this.$router.push("/");
          }
          if (response.data.desativado == 2) {
            this.$router.push("/configuracoes/informacoes_pessoas");
          }
          this.carregouImg = true;
          this.initialize;
        });
    } else {
      this.logout;
    }
  },
  computed: {
    verificaTipo() {
      if (
        this.$store.getters.getTipo == "PE" ||
        this.$store.getters.getTipo == "MT"
      ) {
        return true;
      }
      if (
        this.$store.getters.getTipo == "AD" ||
        this.$store.getters.getTipo == "SA"
      ) {
        if (this.$store.getters.getNotificaSolicitacao == 1) return true;
      }
      return false;
    },
    getLogado() {
      return this.$store.getters.getLogado;
    },
    getDesativado() {
      return this.$store.getters.getDesativado;
    },
    getNome() {
      return this.$store.getters.getNome;
    },
    getFotoPerfil() {
      return this.$store.getters.getFotoPerfil;
    },
    getId() {
      if (this.$store.getters.getTipo != "CO")
        return "#" + this.$store.getters.getId;
      return null;
    },
    getNome() {
      return this.$store.getters.getNome;
    },
    getTipo() {
      return this.$store.getters.getTipo;
    },
    getToken() {
      return this.$store.getters.getToken;
    },
    getPadding() {
      if (this.$route.name != "Login") return "pt-5";
      else return "";
    },
  },

  methods: {
    visualiza_todas() {
      var n = Array.from(this.notif);

      n.forEach((element) => {
        this.qnt = null;
        this.visualiza(element);
      });
      this.atualiza_notificacoes();
      this.notif.splice(0, this.notif.length);
    },
    open_notification(item) {
      this.visualiza(item);
    },
    visualiza(item) {
      var obj = Object.assign({}, this.notif);
      var arr = [];

      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          var innerObj = {};
          innerObj[prop] = obj[prop];
          arr.push(innerObj[prop].idNotificacao);
        }
      }

      item.lista = arr;
      console.log(arr);

      axios
        .post(
          sessionStorage.getItem("url") + "/api/visualiza-notificacao",
          item,
          {
            headers: { Authorization: "Bearer " + this.getToken },
          }
        )
        .then((response) => {
          if (response.data.status == "Token is Expired") {
            this.$store.commit("DESTROY_USER");
            this.$router.push("/");
          }
          if (item.redirect != null) {
            this.$router.push(item.redirect);
            this.qnt = null;
          }
        });
    },
    getUrlImg() {
      if (
        this.carregouImg &&
        this.getFotoPerfil != null &&
        this.getFotoPerfil != ""
      ) {
        return this.url + "/storage/" + this.getFotoPerfil;
      } else {
        return require("@/assets/default2.jpg").default;
      }
    },
    atualiza_notificacoes() {
      if (this.getToken) {
        axios
          .get(
            sessionStorage.getItem("url") + "/api/notificacoes-usuario/normal",
            {
              headers: { Authorization: "Bearer " + this.getToken },
            }
          )
          .then((response) => {
            if (response.data.status == "Token is Expired") {
              this.$store.commit("DESTROY_USER");
              this.$router.push("/");
            }
            this.qnt = response.data.qnt;
            this.notif = response.data.notif;
          });
        if (this.getTipo != "CO") {
          axios
            .get(sessionStorage.getItem("url") + "/api/count-solicitacoes", {
              headers: { Authorization: "Bearer " + this.getToken },
            })
            .then((response) => {
              if (response.data.status == "Token is Expired") {
                this.$store.commit("DESTROY_USER");
                this.$router.push("/");
              }
              this.qnt2 = response.data;
            });
        }
      }
    },
  },
};
</script>
<style lang="css">
.menu {
  margin: 0px;
  min-width: 500px;
  max-height: 50rem;
  position: absolute;
  left: 0px;
  top: 0px;
  right: auto;
  bottom: auto;
  height: auto;
  overflow-x: hidden;
  /* transform: translate(-283px, 16px); */
}
</style>
<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
